import { Layout, Typography, Select, DatePicker, notification } from "antd";
import { toJS } from "mobx";
import { Observer, observer } from "mobx-react-lite";
import moment from "moment";
import { CommandBar } from "@fluentui/react";
import React, { createContext, useContext, useEffect } from "react";
import { Calendar } from "react-feather";
import { SubPageHeaderTitle } from "../../../shared/SubPageHeaderTitle";
import MainStore from "../../home/store/mainStore";

import { Highlight } from "./Highlight";

import HighlightStore from "./store/highlightstore";
import _ from "underscore";
import "./styles/highlight.css";
import HighlightWeek from "../../../Utility/modules/helpers";
import { toAntPickerDate } from "../../../Utility/modules/datePicker";
const HighlightStoreCtx = createContext(HighlightStore);
const MainStoreCtx = createContext(MainStore);
const { Title } = Typography;
const { Content } = Layout;
const { Option } = Select;
export const HighLightBaseView = observer(() => {
  const highlightStore = useContext(HighlightStoreCtx);
  const mainStore = useContext(MainStoreCtx);
  const loadDateHeader = () => {
    const sel = toJS(
      _.first(
        _.where(highlightStore.weeks, { key: highlightStore.selectedWeek })
      )
    );

    highlightStore.selectedWeekName = sel?.text || "";
  };
  const Initalize = () => {
    highlightStore.loadWeeks();
    loadDateHeader();
    highlightStore.selectedMonth = HighlightWeek.getMonth(
      highlightStore.selectedWeek,
      highlightStore.prodYear
    );
   
  };
  useEffect(() => {

    async function loadHighlight() {
      try {
        await highlightStore.loadHighlight(mainStore.assetContextId);
      } catch (error) {
        notification.error({
          message: "SPARS Feedback",
          description: error?.response?.body?.message || error.message,
        });
      }
    }

    Initalize();
     loadHighlight();
  }, []);

  const dateFormat = "YYYY";

  return (
    <Layout
      style={{
        background: "#fff",
        padding: "10px",
        borderTop: "2px solid #ce93d8",
      }}
    >
      <Content>
        <div className="ms-Grid" dir="ltr">
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm4" style={{ display: "flex" }}>
              <SubPageHeaderTitle
                title={`${mainStore.assetContextName} Production Sucesses and Limitations`}
              />
            </div>
            <div
              className="ms-Grid-col ms-sm8"
              style={{ display: "flex", justifyContent: "flex-end" }}
            >
              <Calendar className="calendar-icon" />{" "}
              <Observer>
                {() => (
                  <>
                    <Title
                      level={4}
                      style={{
                        fontSize: "16px",
                        marginLeft: "5px",
                        paddingTop: "5px",
                      }}
                    >
                      Week{highlightStore.selectedWeek}:
                    </Title>
                    <SubPageHeaderTitle
                      title={`${highlightStore.selectedWeekName}`}
                    />{" "}
                  </>
                )}
              </Observer>
            </div>
          </div>{" "}
          <div
            className="ms-Grid-row"
            style={{ borderBottom: "1px solid #F0F2F5", paddingBottom: "5px" }}
          >
            <div className="ms-Grid-col ms-sm12">
              <CommandBar
                items={[
                  { key: "2", text: "Production Year:" },
                  {
                    key: "year",
                    onRender: () => (
                      <DatePicker
                        size="small"
                        placeholder="select production year"
                        style={{ width: "200px" }}
                        picker="year"
                        //value={highlightStore.selDate}
                        defaultValue={toAntPickerDate(new Date())}
                        format={dateFormat}
                        onChange={async (date, val) => {
                          try {
                            highlightStore.prodYear = Number(val);

                            Initalize();
                            // await loadMyApproval();
                          } catch (error) {
                            notification.error({
                              message: "SPARS Feedback",
                              description: error.message,
                            });
                          }
                        }}
                      />
                    ),
                  },
                  { key: "3", text: "Week:" },
                  {
                    key: "cboweek",
                    onRender: () => (
                      <Observer>
                        {() => (
                          <Select
                            showSearch
                            style={{ width: 400 }}
                            placeholder="Select week"
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                              option.children
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                            }
                            value={highlightStore.selectedWeek}
                            onChange= {async(val, obj) => {

                              try {
                                highlightStore.selectedWeek = val;
                              highlightStore.selectedWeekName = obj.children;

                              highlightStore.selectedMonth =
                                HighlightWeek.getMonth(
                                  highlightStore.selectedWeek,
                                  highlightStore.prodYear
                                );
                                await highlightStore.loadHighlight(mainStore.assetContextId)
                              } catch (error) {
                                
                              }
                              
                             
                            }}
                          >
                            {highlightStore.weeks.map((w) => (
                              <Option value={w.key} key={w.key}>
                                {w.text}
                              </Option>
                            ))}
                          </Select>
                        )}
                      </Observer>
                    ),
                  },
                ]}
                farItems={[
                  {
                    key: "4",
                    text: "Export",
                  },
                ]}
              />
            </div>
          </div>
          <div className="ms-Grid-row" style={{ display: "flex" }}>
            <div
              className="ms-Grid-col ms-sm6"
              style={{
                flex: 1,
                borderRight: "1px solid #F0F2F5",
                minHeight: "65vh",
              }}
            >
              <Highlight
                type="highlight"
                color="#87d068"
                emptyText="No Production success recorded for this week"
              />
            </div>
            <div
              className="ms-Grid-col ms-sm6"
              style={{ flex: 1, minHeight: "65vh" }}
            >
              <Highlight
                type="lowlight"
                color="red"
                emptyText="No Production limitation recorded for this week"
              />
            </div>
          </div>
        </div>
      </Content>
    </Layout>
  );
});

